export const getMCPAuthorizationReturnUrl = ({
    search,
    apiHost,
}: {
    search: string;
    apiHost: string;
}): string | null => {
    const nextValue = new URLSearchParams(search).get('next');
    if (!nextValue) {
        return null;
    }

    try {
        const nextUrl = new URL(nextValue, apiHost);
        const expectedUrl = new URL('/mcp/oauth/identity/o/authorize', apiHost);
        if (
            nextUrl.origin !== expectedUrl.origin ||
            nextUrl.pathname !== expectedUrl.pathname ||
            nextUrl.username ||
            nextUrl.password ||
            nextUrl.hash
        ) {
            return null;
        }
        return nextUrl.toString();
    } catch {
        return null;
    }
};
